import React from 'react';
import styled from 'styled-components';
import { Icon } from 'fpay-ui';

const DetailedIcon = styled(Icon)`
  width: ${(props) => props.width};
  height: ${(props) => props.height}
`

export default function ({ src, width, height }) {
  return (
    <DetailedIcon
      icon={src}
      width={width}
      height={height}
    />
  )
}



